// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RedeemDialogButtons-module-container-3cneg{width:100%;display:flex;gap:10px;justify-content:center;margin-top:40px;flex-direction:column}@media(min-width: 768px){.RedeemDialogButtons-module-container-3cneg{flex-direction:row}}", ""]);
// Exports
exports.locals = {
	"container": "RedeemDialogButtons-module-container-3cneg"
};
module.exports = exports;
